import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=f1f12822&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=f1f12822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f12822",
  null
  
)

export default component.exports